import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Tabela from "../Componentes/Tabela";
import { useCallback, useEffect, useRef, useState } from "react";
import { formatarData } from "../Funcoes/FormatarData";
import GenericHeader from "../Componentes/GenericHeader";
import Filters from "../Componentes/Utils/Filters";
import Stats from "../Componentes/Utils/Stats";
import FilterContainer from "../Componentes/Utils/FilterContainer";
import styled from "styled-components";

import useApi from "../hooks/useApi";
const PedidosEpi = () => {
    const api = useApi();


    const [ pedidos, setPedidos ] = useState([])
    const [ pedidosFilter, setPedidosFilter ] = useState([])

    const [ linhas, setLinhas ] = useState( 100 );

    const tabelaRef = useRef( null );

    const GetData = async () => {

        try{

            const { data } = await api.get('/Painel/API/EPI/GetPedidos/')
            console.log( data )

            setPedidos( data )
            setPedidosFilter( data )

        }catch( e ){

            console.log( e )

        }

    }

    useEffect(() => {

        GetData();

    }, [])

    useEffect(() => {

        const element = tabelaRef.current

        if( !element ){

            return;

        }

        const handleScroll = () => {

            const { scrollTop, scrollHeight, clientHeight } = element;

            if( scrollTop + clientHeight >= scrollHeight - 10 ){

                setLinhas(( prev ) => prev + 100 );

            }

        }

        element.addEventListener( 'scroll', handleScroll );

        return () => {

            element.removeEventListener("scroll", handleScroll)

        }

    }, [])

    const TotalText = styled.p`
        margin: auto;
        font-size: 15px;
    `

    const newFormatarData = (dataString) => {
        return `${dataString.substring(0,4)}-${dataString.substring(4,6)}-${dataString.substring(6,8)}`;
    };

    const [ dataIni, setDataIni ] = useState('')
    const [ dataFim, setDataFim ] = useState('')

    const handleFilter = useCallback(() => {

        setPedidosFilter(

            pedidos.filter(( item ) => {

                const data_emissao = new Date(newFormatarData( item.DATA ));

                const filterInicio = !dataIni || data_emissao >= new Date( dataIni )
                const filterFinal = !dataFim || data_emissao <= new Date( dataFim )

                return filterInicio && filterFinal;

            })

        )

    }, [ pedidos, dataIni, dataFim ])

    useEffect(() => {

        handleFilter();

    }, [ handleFilter ])

    return(
        <>
            <NavBar title="PEDIDOS x EPI" prevDest="modulo/ssma/epi" />
            <GenericBody>
                <GenericHeader>
                    <Filters columns="2" >
                        <FilterContainer
                            type="date"
                            valor={ dataIni }
                            changeFunc={( valor ) => setDataIni( valor )}
                        />
                        <FilterContainer
                            type="date"
                            valor={ dataFim }
                            changeFunc={( valor ) => setDataFim( valor )}
                        />
                    </Filters>
                    <Stats>
                        <TotalText><b>TOTAL:</b> { pedidosFilter.length }</TotalText>
                    </Stats>
                </GenericHeader>
                <Tabela ref={ tabelaRef } >
                    <thead>
                        <tr>
                            <th>NUM. PEDIDO</th>
                            <th>COD. EPI</th>
                            <th>DESCRIÇÃO</th>
                            <th>COD. FORNECEDOR</th>
                            <th>FORNECEDOR</th>
                            <th>QUANTIDADE</th>
                            <th>PREÇO</th>
                            <th>PREÇO TOTAL</th>
                            <th>NUM. CA</th>
                            <th>VALIDADE CA</th>
                            <th>DATA EMISSÃO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            pedidosFilter.slice( 0, linhas ).map(( obj, index ) => (
                                <tr key={ index } >
                                    <td>{ obj.PEDIDO }</td>
                                    <td>{ obj.CODIGO }</td>
                                    <td>{ obj.DESCRICAO }</td>
                                    <td>{ obj.FORNECEDOR_COD }</td>
                                    <td>{ obj.FORNECEDOR }</td>
                                    <td>{ obj.QUANTIDADE }</td>
                                    <td>R$ { obj.PRECO }</td>
                                    <td>R$ { obj.PRECO_TOTAL }</td>
                                    <td>{ obj.NUM_CA ? obj.NUM_CA : '-' }</td>
                                    <td>{ obj.VALIDADE_CA ? formatarData( obj.VALIDADE_CA ) : "-" }</td>
                                    <td>{ obj.DATA ? formatarData( obj.DATA ) : "-" }</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Tabela>
            </GenericBody>
        </>
    )

}

export default PedidosEpi;